import {makeObservable, observable} from 'mobx';
import {BaseModel} from "../../../../infrastructure/models/base-model";

export class StandingsWidgetFilterViewModel extends BaseModel {
  @observable entity;

  constructor(entity) {
    super();

    this.entity = entity;

    makeObservable(this);
  }

  get type(): Number {
    return console.error(this.constructor.name + 'Implementation is missing: index');
  }

  get name(): String {
    return console.error(this.constructor.name + 'Implementation is missing: name');
  }
}
